import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

export const getPurchasedCustomPrintForConfigQuery = gql`
  query getPurchasedCustomPrintForConfig($id: RecordID!) {
    albumMembershipGroup(
      id: $id
      root_groups_only: true
      include_matched_photos_only: true
    ) {
      id
      purchased_custom_prints(
        order_statuses: [CUSTOMER_INPUT]
        custom_print_types: [CUSTOM_PRINT, COLLAGE]
        slice: { limit: 1 }
      ) {
        total
        records {
          id
          name
          custom_print {
            id
            name
            type
          }
        }
      }
    }
  }
`;

const getPurchasedCustomPrintForConfigOptions = {
  options: ({ albumMembershipGroupId }) => ({
    variables: {
      id: albumMembershipGroupId,
    },
    fetchPolicy: 'network-only',
  }),
  skip: ({ albumMembershipGroupId }) => !albumMembershipGroupId,
};

const getPurchasedCustomPrintForConfig = graphql(
  getPurchasedCustomPrintForConfigQuery,
  getPurchasedCustomPrintForConfigOptions,
);

export default getPurchasedCustomPrintForConfig;
